import type { Session } from '@supabase/supabase-js';
import { z } from 'zod';

import { apiFetch } from '@/lib/api';

// Client contract for GET /api/v1/admin/operators (cross-operator overview).

export const OperatorsOverviewSchema = z.object({
  operators: z.array(
    z.object({
      id: z.string(),
      slug: z.string(),
      name: z.string(),
      plan: z.string().nullable(),
      subscriptionStatus: z.string().nullable(),
      duplicateSubscriptionId: z.string().nullable(),
      activeProcessor: z.enum(['stripe', 'redsys']).nullable(),
      hostedPageEnabled: z.boolean(),
      createdAt: z.string(),
      bookings30d: z.number(),
      collected30dCents: z.number(),
      lastBookingAt: z.string().nullable(),
    }),
  ),
});

export type OperatorsOverview = z.infer<typeof OperatorsOverviewSchema>;
export type OperatorRow = OperatorsOverview['operators'][number];

export const fetchOperators = (
  session: Session,
  signal?: AbortSignal,
): Promise<OperatorsOverview> =>
  apiFetch('/api/v1/admin/operators', {
    session,
    schema: OperatorsOverviewSchema,
    ...(signal ? { signal } : {}),
  });
